<template>
	<v-layout column>
		<AddEmployeeToRoom v-if="addEmployeeToRoomPayload" v-on:refresh="refreshReport"
			:addEmployeeToRoomPayload="addEmployeeToRoomPayload" />
		<v-card>
			<v-layout row align-center>
				<v-flex shrink class="pl-4 title">EMPLOYEE ASSIGNED SPACE REPORT</v-flex>
				<v-flex grow>
					<v-tooltip bottom>
						<v-btn slot="activator" icon @click="refreshReport"><v-icon>refresh</v-icon></v-btn>
						Refresh
					</v-tooltip>
					<v-tooltip bottom>
						<v-btn slot="activator" icon @click="exportTable" class="ml-0"><v-icon>save_alt</v-icon></v-btn>
						Export Data
					</v-tooltip>
					</v-flex>
				
				<v-flex shrink class="ma-2">
					<v-select
						v-model="selectedType"
						@change="addTypeFilter"
						outline
						
						dense
			            hide-details			               
			            :items="type"
			            label="PI / Occupant">
			        </v-select>
			    </v-flex>
				<v-flex shrink class="ma-2">
					<v-select
						v-model="selectedStatus"
						@change="addStatusFilter"
						outline
						
						dense
			            hide-details			               
			            :items="status"
			            label="Status">
			        </v-select>
			    </v-flex>
			</v-layout>
        </v-card>
        <div><v-alert style="color: black;" :value="true" type="success" dismissible>Lists all Employees for a department and their assigned space (if any).  An employee assigned two rooms will have two rows.<br>Clicking an unassigned employee will allow you to assign space to them.</v-alert></div>
		<v-card v-if="employees" height="100%" class="mt-3">
			<v-data-table
				v-model="selected"
				:headers="headersCalc"
				:items="filteredEmployees"
				item-key="roomNumber"
				select-all
      			:rows-per-page-items="rowsPerPage"
				@input="updateSelected"
				
				class="listoverflow1">
			  	<template v-slot:items="props">
			  		

			  		<tr  @click="rowClick(props.item)" style="height: 10px; !important; cursor: pointer;"
						:id="props.item" :active="props.selected" >
					 	<td>
							<v-checkbox @click.stop="props.selected = !props.selected" 
								hide-details
								color="primary"
								:input-value="props.selected">									
							</v-checkbox>
						</td>
						
						<td class="caption" v-for="(header, index) in headersCalc" v-bind:key="index">
							<v-tooltip top>
								<span slot="activator">{{ props.item[header.value] }}</span>
								<span>View Room Detail</span>
								</v-tooltip>
						</td>
						
					
					</tr>
					
			  	</template>
			</v-data-table>
		</v-card>
	</v-layout>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import AddEmployeeToRoom from '@/components/forms/AddEmployeeToRoom'
import XLSX from 'xlsx'

export default {
data () {
	return {
		page: 1,
        pageCount: 0,
        rowsPerPage: [250,500,1000,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
		selectedStatus: 'All',
		selectedType: 'All',
		selected: [],
		addEmployeeToRoomPayload: null,
		headersDept: 	[			        
				        { text: 'Room',	value: 'roomNumber' },
				        { text: 'Building',	value: 'building' },			        
				        { text: 'Name',	align: 'left',	value: 'name' },
				        { text: 'Title',	value: 'title' },
				        { text: 'ID',	value: 'employeeID' },
				        { text: 'Type',	value: 'type' },
				        { text: 'Status',	value: 'status' },			        
			      	],
		headersCollege: 	[			        
				        { text: 'Room',	value: 'roomNumber' },
				        { text: 'Building',	value: 'building' },			        
				        { text: 'Name',	align: 'left',	value: 'name' },
				        { text: 'Title',	value: 'title' },
						{ text: 'Dept', value: 'department' },
				        { text: 'ID',	value: 'employeeID' },
				        { text: 'Type',	value: 'type' },
				        { text: 'Status',	value: 'status' },			        
			      	],
		filters:  	[ 
						{ property: 'status', 	value: 'All' },
						{ property: 'type', value: 'All' },
			 		],
	}
},

components: { AddEmployeeToRoom, },

computed: {
	...mapState({   	employees:			state => state.dashboard.employees,
						selectedDept:		state => state.dashboard.selectedDept,
						selectedCollege:	state => state.dashboard.selectedCollege,
						showAddEmployeeToRoomDialog: state => state.ui.showAddEmployeeToRoomDialog,
				}),
	...mapGetters([ 'getRoom', 'isManagerOfDept', 'isOccupantEditorOfDept', 'getDepartment' ]),

	status: function () {
  		const items = this.employees && this.employees.map((employee) => {  return employee.status })
  		//items.push("All")
  		return ['All'].concat(items)
  		//return items && items.filter((item) => item != null).sort()
  	},

  	type: function () {
  		return ['All', 'Occupant', 'PI' ]
  	},

	filteredEmployees: function () {
		let returnitems = this.employees
		if (this.filters) {
  				// Successive Filtering for each filterterm
                this.filters.forEach((filter) => {
                	if (filter.value && filter.value != "All") {
                		returnitems = returnitems.filter((item) => item[`${filter.property}`] == filter.value )
                }
            })
		} 
  		return returnitems
	},

	headersCalc: function() {
		if(this.selectedDept) {
			return this.headersDept
		}

		return this.headersCollege
	}
},

methods : {
	...mapMutations([ 	'updateBulkRoomEditSideBar', 'setMultiSelectRoomArray', 'setRoomNoRoute', 
						'fetchBuildingRooms', 'updateContentSidebar', 'setShowAddEmployeeToRoomDialog', ]),
	...mapActions([		'fetchDeptOccupantPIs', 'fetchFullRoom'										]),

	rowClick : async function (row) {
		// Opens Room in new Tab
		//let routeData = this.$router.resolve({name: 'home'});
		//window.open(routeData.href && `/bldgviewer/${row.room.bldgAlpha}/${row.room.number}`, '_blank');

		if (row.building) {
			let room = await this.fetchFullRoom({ bldgAlpha: row.building, number: row.roomNumber, noSet: true })
			this.setRoomNoRoute(room) // pre-fetched data		
			this.updateContentSidebar(true)
		} else { // This click was on a person with no room assignment
			//console.log("Popup Employee Add Room Window", row)
			// only show if this is manager
			if (this.selectedDept) {
				if (this.isManagerOfDept(this.selectedDept) || this.isOccupantEditorOfDept(this.selectedDept) ) {		
					this.addEmployeeToRoomPayload = row
					this.setShowAddEmployeeToRoomDialog(true)
				}
			}
			else {
				let dept = this.getDepartment(row.department)
				if (this.isManagerOfDept(dept) || this.isOccupantEditorOfDept(dept) ) {		
					this.addEmployeeToRoomPayload = row
					this.setShowAddEmployeeToRoomDialog(true)
				}
			}
		}
	},

	refreshReport: function () {
		//console.log("REFRESH")
		this.$emit('refresh')
	},

	addStatusFilter: function (value) {		
		this.addFilter("status", value)			
	},

	addTypeFilter: function (value) {		
		this.addFilter("type", value)			
	},

	addFilter: function (property, value) {
		const index = this.filters.findIndex(filter => filter.property==property)
		this.filters[index].value = value
		//console.log(this.filters)
	},

	updateSelected: function (value) {
		let rooms = value.map((employee) => { 
			return { roomKey: employee.roomKey,
					 number:    employee.roomNumber,
					 bldgAlpha: employee.building,  
			} })
		this.setMultiSelectRoomArray(rooms)
		if (rooms.length > 0)  { this.updateBulkRoomEditSideBar(true)  }
		else 					{ this.updateBulkRoomEditSideBar(false) }
	},

	exportTable(){

		if(this.selectedDept) {
			// A workbook is the name given to an Excel file
			var wb = XLSX.utils.book_new() // make Workbook of Excel

			// Create worksheet, and add info
			let ws = XLSX.utils.aoa_to_sheet([
					["UArizona Interactive Floorplans"],
					["Employee Occupancy Report for " + this.selectedDept.deptID + " - " + this.selectedDept.deptName],
				])


			// Column Widths
			var wscols = [
				{wch:8},
				{wch:8},
				{wch:30},
				{wch:50},
				{wch:10},
				{wch:10},
				{wch:10},
			];

			ws['!cols'] = wscols;

			let empData = this.filteredEmployees.map((emp) => {
					return 	{	
							Room:	emp.roomNumber,
							Bldg:	emp.building, 
							Name:	emp.name,
							Title:	emp.title,
							ID:		emp.employeeID,
							Type:	emp.type,
							Status:	emp.status
						}
				})
				
			//Add data to sheet
			XLSX.utils.sheet_add_json(ws, empData, { origin:"A4" })
			
			// add Worksheet to Workbook
			XLSX.utils.book_append_sheet(wb, ws, "Employee Assigned Space")
			
			// export Excel file
			XLSX.writeFile(wb, 'EmployeeAssignedSpace.xlsx') // name of the file is 'book.xlsx'   
		}
		else {
			// A workbook is the name given to an Excel file
			var wb = XLSX.utils.book_new() // make Workbook of Excel

			// Create worksheet, and add info
				let ws = XLSX.utils.aoa_to_sheet([
					["UArizona Interactive Floorplans"],
					["Employee Occupancy Report for " + this.selectedCollege.id + " - " + this.selectedCollege.name],
				])
			

			// Column Widths
			var wscols = [
				{wch:8},
				{wch:8},
				{wch:30},
				{wch:50},
				{wch:10},
				{wch:10},
				{wch:10},
				{wch:10},
			];

			ws['!cols'] = wscols;

			let empData = this.filteredEmployees.map((emp) => {
					return 	{	
							Room:	emp.roomNumber,
							Bldg:	emp.building, 
							Name:	emp.name,
							Title:	emp.title,
							Dept:	emp.department,
							ID:		emp.employeeID,
							Type:	emp.type,
							Status:	emp.status
						}
				})
				
			//Add data to sheet
			XLSX.utils.sheet_add_json(ws, empData, { origin:"A4" })
			
			// add Worksheet to Workbook
			XLSX.utils.book_append_sheet(wb, ws, "Employee Assigned Space")
			
			// export Excel file
			XLSX.writeFile(wb, 'EmployeeAssignedSpace.xlsx') // name of the file is 'book.xlsx'   
		}
	},
},
}


</script>

<style>
.listoverflow1 {		/* This sets the list's height to 100% of the card minus other objects.  In this case toolbar + some text (128px) */
	overflow-y: auto;
	height: calc(100vh - 430px);  
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/reports/EmployeeReport.vue